<mat-progress-bar
  [mode]="(isLoadingData$ | async) ? 'indeterminate' : 'determinate'"
  color="primary">
</mat-progress-bar>

<mat-tab-group
  mat-stretch-tabs="false"
  animationDuration="0"
  (selectedIndexChange)="onTabChange($event)"
  [selectedIndex]="selectedTabIndex"
>

  <mat-tab label="Equipos">
    <ng-template matTabContent>
      <app-search-tab-team [statsMode]="statsMode"></app-search-tab-team>
    </ng-template>
  </mat-tab>

  <mat-tab label="Partidos" *ngIf="statsMode === 'actas'">
    <ng-template matTabContent>
      <app-search-tab-match></app-search-tab-match>
    </ng-template>
  </mat-tab>

  <mat-tab label="Jugadores" *ngIf="statsMode === 'actas'">
    <ng-template matTabContent>
      <app-search-tab-player></app-search-tab-player>
    </ng-template>
  </mat-tab>

</mat-tab-group>
